import React, { Fragment } from 'react';
import C2Input from '../propComponents/C2Input.js';
import C2Select from '../propComponents/C2Select.js';
import C2BtnGroup from '../propComponents/C2BtnGroup.js';
import C2ColorPicker from '../propComponents/C2ColorPicker.js';
import C2Switch from '../propComponents/C2Switch.js';
import C2Textarea from '../propComponents/C2Textarea.js';
import C2InputNumber from '../propComponents/C2InputNumber.js';

const PropsEditor = (props) => {
    const handleChange = (e) => {
        props.propsUpdated(Object.assign(Object.assign({}, props.params), e));
    };
    const factory = (opts, index) => {
        let component = null;
        switch (opts.type) {
            case "select":
                component = React.createElement(C2Select, { opts: opts, onChange: (e) => handleChange(e) });
                break;
            case "input":
                component = React.createElement(C2Input, { opts: opts, params: props.params, onChange: (e) => handleChange(e) });
                break;
            case "inputnumber":
                component = React.createElement(C2InputNumber, { opts: opts, params: props.params, onChange: (e) => handleChange(e) });
                break;
            case "textarea":
                component = React.createElement(C2Textarea, { opts: opts, params: props.params, onChange: (e) => handleChange(e) });
                break;
            case "buttonGroup":
                component = React.createElement(C2BtnGroup, { opts: opts });
                break;
            case "colorpicker":
                component = React.createElement(C2ColorPicker, { opts: opts });
                break;
            case "switch":
                component = React.createElement(C2Switch, { opts: opts, onChange: (e) => handleChange(e) });
                break;
        }
        return React.createElement("div", { className: "py-3", key: index }, component);
    };
    return React.createElement(Fragment, null, props.selectedProps && props.selectedProps.map((opt, index) => factory(opt, index)));
};

export { PropsEditor as default };
//# sourceMappingURL=PropsEditor.js.map
